(() => {
  'use strict';
  const root=document.getElementById('nk-tour');
  if(!root||root.dataset.ready)return;
  root.dataset.ready='true';
  const config=JSON.parse(root.querySelector('[data-nk-config]').textContent), text=config.text;
  const panel=root.querySelector('.nk-bubble'),body=root.querySelector('[data-nk-body]'),launcher=root.querySelector('[data-nk-launch]'),character=root.querySelector('.nk-character-row'),status=root.querySelector('[data-nk-status]'),motion=root.querySelector('[data-nk-motion]');
  if(config.preview&&config.themeId){
    document.addEventListener('click',event=>{
      const anchor=event.target.closest?.('a[href]');
      if(!anchor||anchor.hasAttribute('download'))return;
      const target=new URL(anchor.href,location.href);
      if(target.origin!==location.origin||target.searchParams.has('preview_theme_id'))return;
      const path=target.pathname.replace(/^\/(en|de)(?=\/|$)/,'');
      if(!/^\/(?:$|pages\/|products\/|collections\/|blogs\/)/.test(path||'/'))return;
      if(target.pathname===location.pathname&&target.hash&&target.search===location.search)return;
      target.searchParams.set('preview_theme_id',String(config.themeId));
      target.searchParams.set('pb','0');anchor.href=target.href;
    },true);
  }
  const homeDock=config.home?document.querySelector('[data-nk-home]'):null;
  if(homeDock){
    root.dataset.inline='true';homeDock.append(root);
    const invitation=launcher.lastElementChild;
    invitation.className='nk-invitation';
    invitation.replaceChildren();
    [
      ['nk-invitation-title',text.play_title],
      ['nk-invitation-detail',text.play_detail],
      ['nk-invitation-cta',text.play_cta]
    ].forEach(([className,text])=>{
      const line=document.createElement('span');
      line.className=className;line.textContent=text;invitation.append(line);
    });
    launcher.setAttribute('aria-label',text.play_open);
  }
  const mobileMedia=matchMedia('(max-width: 760px)'),originalParent=root.parentNode,originalNext=root.nextSibling;
  const mobileMain=!homeDock?document.querySelector('#MainContent,main'):null;
  const mobileDock=mobileMain?document.createElement('div'):null;
  if(mobileDock){mobileDock.className='nk-mobile-dock';mobileMain.prepend(mobileDock);}
  function placeTour(){
    if(!mobileDock)return;
    if(mobileMedia.matches){
      mobileDock.hidden=false;root.dataset.mobileInline='true';mobileDock.append(root);
    }else{
      delete root.dataset.mobileInline;mobileDock.hidden=true;
      originalParent.insertBefore(root,originalNext?.parentNode===originalParent?originalNext:null);
    }
  }
  placeTour();mobileMedia.addEventListener('change',()=>{placeTour();schedule();});
  const mq=matchMedia('(prefers-reduced-motion: reduce)'),key='nd-nokirumi-welcome-v1-'+config.scope;
  const ids=config.rooms.map(r=>r.id),maxAge=15552000000;
  let state='CLOSED',timers=[],pending=null,started=false,frame=0,returnPosition=null;
  let saved={seen:false,mode:'new',panelOpen:false,paused:false,voiceMuted:false,visited:[],completed:false,updatedAt:0};
  const preferencesAllowed=()=>window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.()===true;
  function restore(){
    try{
      // A tab restored from history may hold an older session snapshot.
      // Only consult shared preferences when the visitor has allowed them.
      const candidates=[];
      const read=storage=>{
        try{
          const value=JSON.parse(storage.getItem(key));
          if(value&&Number.isFinite(value.updatedAt)&&Date.now()-value.updatedAt<maxAge)candidates.push(value);
        }catch(_){}
      };
      read(sessionStorage);
      if(preferencesAllowed())read(localStorage);
      const s=candidates.sort((a,b)=>b.updatedAt-a.updatedAt)[0];
      if(!s||s.updatedAt<saved.updatedAt)return;
      saved={seen:s.seen===true,panelOpen:typeof s.panelOpen==='boolean'?s.panelOpen:s.mode==='guided'&&s.completed!==true,mode:['new','solo','guided'].includes(s.mode)?s.mode:'new',paused:s.paused===true,voiceMuted:s.voiceMuted===true,visited:[...new Set(Array.isArray(s.visited)?s.visited.filter(id=>ids.includes(id)):[])],completed:s.completed===true,updatedAt:s.updatedAt};
      saved.completed=saved.mode==='guided'&&saved.visited.length===4;
      syncLauncher();
    }catch(_){}
  }
  function save(){
    saved.updatedAt=Date.now();syncLauncher();
    try{sessionStorage.setItem(key,JSON.stringify(saved));}catch(_){}
    try{if(preferencesAllowed())localStorage.setItem(key,JSON.stringify(saved));else localStorage.removeItem(key);}catch(_){}
  }

  const voiceButton=root.querySelector('[data-nk-voice]'),voiceAudio=document.createElement('audio');
  voiceAudio.preload='none';voiceAudio.hidden=true;voiceAudio.dataset.nkAudio='';root.append(voiceAudio);
  let voiceKey='',voiceBlocked=false,voiceFailed=false,voiceGeneration=0,voicePending=false;
  const voiceQuiet=()=>document.documentElement.dataset.noise==='off';
  function voiceUI(){
    if(!voiceButton)return;
    voiceButton.disabled=voiceQuiet();
    voiceButton.textContent=voiceQuiet()?text.voice_noise:saved.voiceMuted?text.voice_enable:voiceBlocked?text.voice_tap:voiceFailed?text.voice_retry:text.voice_mute;
    voiceButton.setAttribute('aria-pressed',String(saved.voiceMuted||voiceQuiet()));
    root.dataset.voice=voiceQuiet()||saved.voiceMuted?'muted':voiceBlocked?'blocked':voiceFailed?'error':voicePending?'loading':!voiceAudio.paused?'playing':'ready';
  }
  function stopVoice(){
    voiceGeneration++;voicePending=false;voiceAudio.pause();voiceAudio.removeAttribute('src');voiceAudio.load();voiceKey='';voiceBlocked=false;voiceFailed=false;voiceUI();
  }
  function interruptVoice(){const current=voiceKey;stopVoice();voiceKey=current;voiceBlocked=!!current;voiceUI();}
  function speakVoice(name){
    stopVoice();voiceKey=name;
    const clip=config.voiceClips?.[name];
    if(!clip||saved.voiceMuted||voiceQuiet()||root.hidden||panel.hidden){voiceUI();return;}
    const generation=voiceGeneration;
    voiceAudio.src=clip.url;voicePending=true;voiceUI();
    const attempt=voiceAudio.play();
    attempt?.then(()=>{if(generation!==voiceGeneration)return;voicePending=false;voiceBlocked=false;voiceUI();}).catch(error=>{
      if(generation!==voiceGeneration)return;
      voicePending=false;
      voiceBlocked=error.name==='NotAllowedError';
      voiceFailed=!voiceBlocked&&error.name!=='AbortError';voiceUI();
    });
  }
  function afterSpeech(fn,minimum){
    const check=()=>{
      if(!saved.voiceMuted&&!voiceQuiet()&&(voicePending||voiceBlocked||!voiceAudio.paused)){later(check,500);return;}
      fn();
    };
    later(check,minimum);
  }
  voiceAudio.addEventListener('ended',voiceUI);
  voiceAudio.addEventListener('error',()=>{if(voiceAudio.hasAttribute('src')){voicePending=false;voiceFailed=true;voiceUI();}});
  voiceButton?.addEventListener('click',()=>{
    if(voiceQuiet())return;
    if(saved.voiceMuted||voiceBlocked||voiceFailed){
      saved.voiceMuted=false;save();speakVoice(voiceKey);
    }else{saved.voiceMuted=true;save();const current=voiceKey;stopVoice();voiceKey=current;voiceUI();}
  });
  function quietVoice(){if(voiceQuiet())interruptVoice();voiceUI();}
  document.addEventListener('nd:noise',quietVoice);
  new MutationObserver(quietVoice).observe(document.documentElement,{attributes:true,attributeFilter:['data-noise']});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)interruptVoice();});
  window.addEventListener('pagehide',stopVoice);

  function calm(){return mq.matches||saved.paused||document.documentElement.dataset.noise==='off'||document.documentElement.dataset.motion==='reduce';}
  function syncMotion(){root.dataset.calm=String(calm());motion.textContent=saved.paused?text.allow_motion:text.pause_motion;motion.setAttribute('aria-pressed',String(saved.paused));}
  function emit(name,params={}){
    const detail={experience:'nokirumi_quest_v1',language:config.language,...params};
    if(config.preview){root.dataset.lastEvent=name;root.dataset.eventDetail=JSON.stringify(detail);return;}
    if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()!==true)return;
    try{const result=window.Shopify?.analytics?.publish?.(name,detail);result?.catch?.(()=>{});}catch(_){}
  }
  function announce(value){status.textContent=value;}
  function later(fn,delay){timers.push(setTimeout(fn,delay));}
  function transition(next){if(!(state==='QUEST_INTRO'&&next==='ROOM_SELECTION'))stopVoice();timers.forEach(clearTimeout);timers=[];state=next;root.dataset.state=next;syncMotion();}
  function el(tag,className,value){const n=document.createElement(tag);if(className)n.className=className;if(value)n.textContent=value;return n;}
  function p(value,className){const n=el('p',className,value);body.append(n);return n;}
  function button(label,fn,primary=false){const b=el('button','nk-choice'+(primary?' nk-choice--primary':''),label);b.type='button';b.addEventListener('click',fn);return b;}
  function link(label,url,kind,primary=false){
    const a=el('a','nk-choice'+(primary?' nk-choice--primary':''),label);a.href=url;
    if(kind==='reward'){a.target='_blank';a.rel='noopener';}
    if(kind)a.addEventListener('click',()=>emit(kind==='reward'?'nokirumi_reward_clicked':'nokirumi_product_clicked',{destination:kind==='reward'?'brain_reset_bingo':new URL(url,location.origin).pathname}));
    return a;
  }
  function open(next,focus=false){
    transition(next);if(!saved.panelOpen){saved.panelOpen=true;save();}root.hidden=false;panel.hidden=false;launcher.hidden=true;character.hidden=false;body.replaceChildren();panel.scrollTop=0;launcher.setAttribute('aria-expanded','true');
    if(focus){
      root.querySelector('h2').focus({preventScroll:true});
      if(homeDock)requestAnimationFrame(()=>root.scrollIntoView({block:'start',behavior:'instant'}));
    }
    schedule();
  }
  function progress(){
    const group=el('div','nk-progress');
    group.append(el('p','nk-progress-label',text.progress.replace('[count]',saved.visited.length)));
    const meter=el('progress');meter.max=4;meter.value=saved.visited.length;meter.setAttribute('aria-label',text.rooms);group.append(meter);body.append(group);
    root.dataset.progress=String(saved.visited.length);
  }
  function rest(){
    restore();const returnFocus=panel.contains(document.activeElement);
    pending=null;saved.seen=true;saved.panelOpen=false;save();transition('RESTING');panel.hidden=true;character.hidden=true;launcher.hidden=false;launcher.setAttribute('aria-expanded','false');
    if(returnFocus&&!root.hidden)launcher.focus({preventScroll:true});
    if(returnPosition!==null){window.scrollTo({top:returnPosition,behavior:'instant'});returnPosition=null;}
  }
  function welcome(focus=false){
    pending=null;root.dataset.celebrate='false';saved.seen=true;save();open('WELCOME',focus);p(text.welcome);
    later(()=>{if(state!=='WELCOME')return;p(text.question);const actions=el('div','nk-actions');actions.append(button(text.guided,()=>startTour(),true),button(text.solo,solo));body.append(actions);announce(text.welcome+' '+text.question);},calm()?0:650);
    speakVoice('welcome');emit('nokirumi_welcome_shown');
  }
  function rooms(){
    const nav=el('nav','nk-rooms');nav.setAttribute('aria-label',text.rooms);
    config.rooms.forEach(room=>{
      const done=saved.visited.includes(room.id),a=link(room.name,room.url);
      a.dataset.room=room.id;
      a.addEventListener('click',()=>{if(saved.mode!=='guided'){saved.mode='guided';saved.seen=true;save();emit('nokirumi_tour_started');}});
      const here=currentRoom()?.id===room.id;
      if(here)a.setAttribute('aria-current','page');
      a.setAttribute('aria-label',room.name+' — '+(here?text.current:done?text.discovered:text.explore));
      if(done)a.classList.add('nk-visited');
      a.append(el('span','nk-room-mark',done?'✓':'↗'));a.lastChild.setAttribute('aria-hidden','true');nav.append(a);
    });
    body.append(nav);
  }
  // Games are an optional detour; room discoveries stay independent.
  const playContextKey=key+'-play-return';
  function playContext(){
    try{
      const value=JSON.parse(sessionStorage.getItem(playContextKey));
      const url=new URL(value?.url,location.origin);
      if(value&&Date.now()-value.at<3600000&&url.origin===location.origin&&/^\/(?:de\/|en\/)?(?:$|pages\/|collections\/|products\/|blogs\/)/.test(url.pathname))return {...value,url:url.href};
    }catch(_){}
    return null;
  }
  function clearPlayContext(){try{sessionStorage.removeItem(playContextKey);}catch(_){}}
  function gamesLink(){
    if(!config.gamesUrl)return;
    const a=link(text.games,config.gamesUrl);a.dataset.playMenu='';
    a.addEventListener('click',()=>{
      restore();save();
      try{sessionStorage.setItem(playContextKey,JSON.stringify({url:location.href,at:Date.now(),panelOpen:!panel.hidden}));}catch(_){}
      stopVoice();
    });
    body.append(a);
  }
  function menu(focus=true,intro=false){
    open(intro?'QUEST_INTRO':saved.visited.length?'QUEST_IN_PROGRESS':'ROOM_SELECTION',focus);
    const room=currentRoom();
    if(!intro&&room){p(text.current_room.replace('[room]',room.name),'nk-stamp');p(text[room.id+'_line']);}
    else p(intro?text.intro:saved.completed?text.all_discovered:text.resume);
    progress();p(saved.completed?text.revisit:saved.visited.length?text.continue_question:text.start);rooms();
    const actions=el('div','nk-actions');actions.append(button(text.keep_browsing,rest));body.append(actions);
    gamesLink();
    if(saved.completed)body.append(button(text.view_reward,()=>complete(true,false)));
    announce((room?text.current_room.replace('[room]',room.name)+'. ':'')+text.progress.replace('[count]',saved.visited.length)+' '+(saved.completed?text.revisit:saved.visited.length?text.continue_question:text.start));
    speakVoice(intro?'intro':room?room.id:saved.completed?'revisit':'resume');
    if(intro)later(()=>{if(state==='QUEST_INTRO')transition('ROOM_SELECTION');},650);
  }
  function normalize(url){const path=decodeURIComponent(new URL(url,location.origin).pathname).replace(/\/$/,'');return path.replace(/^\/(en|de)(?=\/|$)/,'')||'/';}
  function currentRoom(){
    const path=normalize(location.href);
    return config.rooms.find(room=>room.id===config.pageRoom)||
      config.rooms.find(room=>[room.url,...(room.paths||[]),...room.links.filter(item=>item.kind!=='reward').map(item=>item.url)].some(url=>normalize(url)===path)||
        (room.id==='stories'&&path.startsWith(normalize(room.url)+'/')));
  }
  function syncLauncher(){
    root.dataset.progress=String(saved.visited.length);
    if(saved.mode==='guided'){
      const label=(saved.completed?text.tour_done:text.continue_tour)+' · '+text.progress.replace('[count]',saved.visited.length);
      launcher.setAttribute('aria-label',label);
      const title=launcher.querySelector('.nk-invitation-title');
      if(title)title.textContent=saved.completed?text.tour_done:text.continue_tour;
      else launcher.lastElementChild.textContent=saved.completed?text.tour_done:text.continue_tour;
      const detail=launcher.querySelector('.nk-invitation-detail');
      if(detail)detail.textContent=text.progress.replace('[count]',saved.visited.length);
      const cta=launcher.querySelector('.nk-invitation-cta');
      if(cta)cta.textContent=saved.completed?text.view_reward:text.continue_tour+' →';
    }else{
      launcher.setAttribute('aria-label',homeDock?text.play_open:text.open);
      const title=launcher.querySelector('.nk-invitation-title');
      if(title)title.textContent=text.play_title;
      else launcher.lastElementChild.textContent=text.launcher;
      const detail=launcher.querySelector('.nk-invitation-detail');
      if(detail)detail.textContent=text.play_detail;
      const cta=launcher.querySelector('.nk-invitation-cta');
      if(cta)cta.textContent=text.play_cta;
    }
  }
  function resume(focus=false){
    restore();pending=null;root.dataset.celebrate='false';
    const room=currentRoom();
    if(saved.mode==='guided'){
      if(room&&!saved.visited.includes(room.id))discover(room,focus);
      else menu(focus);
    }else welcome(focus);
  }
  function startTour(){
    restore();
    saved.mode='guided';saved.seen=true;save();emit('nokirumi_tour_started');
    const room=currentRoom();
    if(room&&!saved.visited.includes(room.id))discover(room,true);else menu(true,true);
  }
  function solo(){
    saved.mode='solo';saved.seen=true;save();open('SOLO_EXPLORER',true);p(text.solo_reply);p(text.solo_rest);announce(text.solo_reply+' '+text.solo_rest);emit('nokirumi_solo_selected');speakVoice('solo');afterSpeech(rest,6000);
  }
  function discover(room,focus=false){
    if(saved.mode!=='guided'||saved.visited.includes(room.id))return;
    saved.visited.push(room.id);save();emit('nokirumi_room_visited',{room:room.id,rooms_explored:saved.visited.length});
    const last=saved.visited.length===4;
    if(last){saved.completed=true;save();emit('nokirumi_quest_completed',{rooms_explored:4});}
    open('ROOM_DISCOVERED',focus);p(room.name+' · '+text.discovered,'nk-stamp');p(text[room.id+'_line']);progress();
    p(text[room.id+'_detail'],'nk-small');
    const actions=el('div','nk-actions');
    room.links.forEach((item,i)=>actions.append(link(item.label,item.url,item.kind,i===0&&room.id==='tools')));
    actions.append(button(last?text.finish:text.next,()=>last?complete(true,true):menu(true),last));
    actions.append(button(text.keep_browsing,rest));body.append(actions);
    gamesLink();
    announce(room.name+' '+text.discovered+'. '+text.progress.replace('[count]',saved.visited.length));
    speakVoice(room.id);
    if(last)afterSpeech(()=>{if(state==='ROOM_DISCOVERED'&&!panel.contains(document.activeElement))complete(false,true);},6500);
  }
  function complete(focus=false,celebrate=false){
    open('QUEST_COMPLETE',focus);root.dataset.celebrate=String(celebrate&&!calm());p(text.complete_title,'nk-complete-title');p(text.complete_line);progress();p(text.complete_invite);
    const actions=el('div','nk-actions');actions.append(link(text.reward,config.reward,'reward',true),link(text.tools,config.rooms.find(r=>r.id==='tools').url));body.append(actions);
    p(text.reward_note,'nk-small');body.append(button(text.browse_rooms,()=>menu(true)));
    gamesLink();
    announce(text.complete_title+' '+text.complete_line);speakVoice('complete');
  }
  function restart(){
    open('CLOSED',true);p(text.restart_question);
    const actions=el('div','nk-actions');actions.append(button(text.restart_confirm,()=>{
      saved={seen:true,mode:'new',panelOpen:false,paused:saved.paused,voiceMuted:saved.voiceMuted,visited:[],completed:false,updatedAt:0};save();root.dataset.progress='0';root.dataset.celebrate='false';
      transition('CLOSED');panel.hidden=true;launcher.hidden=true;character.hidden=true;pending={type:'welcome'};obstruction();
    },true),button(text.cancel,()=>saved.completed?complete(true,false):menu(true)));body.append(actions);
  }
  launcher.addEventListener('click',()=>{returnPosition=window.scrollY;resume(true);});
  root.querySelector('[data-nk-close]').addEventListener('click',rest);
  root.querySelector('[data-nk-restart]').addEventListener('click',restart);
  motion.addEventListener('click',()=>{saved.paused=!saved.paused;save();syncMotion();});
  root.addEventListener('keydown',e=>{if(e.key==='Escape'&&!panel.hidden){e.stopPropagation();rest();}});
  mq.addEventListener('change',syncMotion);
  document.addEventListener('nd:noise',syncMotion);document.addEventListener('nd:motion',syncMotion);
  document.addEventListener('visitorConsentCollected',()=>{restore();save();syncMotion();});
  const visible=el=>{const r=el.getBoundingClientRect();return r.width>0&&r.height>0&&getComputedStyle(el).visibility!=='hidden'&&getComputedStyle(el).display!=='none';};
  const watchedChat=new WeakSet(),watchedControls=new WeakSet();
  const chatChanges=new MutationObserver(schedule),chatSizes=new ResizeObserver(schedule);
  function chatLayout(){
    const hosts=[...document.querySelectorAll('shopify-chat')],launchers=[];
    let opened=hosts.some(host=>host.hasAttribute('open'));
    const inspect=scope=>{
      if(!scope||watchedChat.has(scope))return;
      watchedChat.add(scope);
      chatChanges.observe(scope,{subtree:true,childList:true,attributes:true,attributeFilter:['open','class','hidden','style','aria-expanded','inert']});
      scope.addEventListener('transitionend',schedule);
    };
    hosts.forEach(host=>{
      const outer=host.shadowRoot;
      inspect(outer);
      const inner=outer?.querySelector('shopify-agent-runtime')?.shadowRoot;
      inspect(inner);
      [outer,inner].filter(Boolean).forEach(scope=>{
        scope.querySelectorAll('[part~="activator"],button[aria-expanded]').forEach(control=>{
          if(!control.matches('[part~="activator"]'))return;
          if(!watchedControls.has(control)){watchedControls.add(control);chatSizes.observe(control);}
          if(control.getAttribute('aria-expanded')==='true')opened=true;
          if(visible(control))launchers.push(control);
        });
      });
    });
    return {opened,launchers};
  }
  let gameOpen=false,gameReturnOpen=false;
  function suspendForPlay(){
    restore();gameReturnOpen=!panel.hidden||playContext()?.panelOpen===true;
    gameOpen=true;timers.forEach(clearTimeout);timers=[];interruptVoice();root.hidden=true;
    const dialog=document.querySelector('[data-play-dialog]');
    if(!dialog)return;
    let strip=dialog.querySelector('[data-nk-play-return]');
    if(!strip){strip=el('div','nk-play-return');strip.dataset.nkPlayReturn='';dialog.querySelector('[data-play-bar],.nd-play__bar')?.after(strip);}
    strip.replaceChildren();
    const context=playContext(),otherPage=context&&normalize(context.url)!==normalize(location.href);
    const label=text.games_return+' · '+text.progress.replace('[count]',saved.visited.length);
    const control=otherPage?link(label,context.url):button(label,()=>dialog.close());
    if(otherPage)control.addEventListener('click',()=>{saved.panelOpen=true;save();clearPlayContext();window.NDGameSound?.stop();});
    strip.append(control);
  }
  document.addEventListener('nd:play-open',suspendForPlay);
  document.addEventListener('nd:play-close',()=>{
    gameOpen=false;const reopen=gameReturnOpen;gameReturnOpen=false;clearPlayContext();
    window.NDGameSound?.stop();syncLauncher();schedule();
    // Wait until the dialog has restored focus before restoring the tour.
    requestAnimationFrame(()=>{
      if(gameOpen)return;
      obstruction();
      if(reopen&&!root.hidden){pending=null;resume(false);root.querySelector('h2').focus({preventScroll:true});}
    });
  });
  function obstruction(){
    if(gameOpen){root.hidden=true;return;}
    const blockers=[...document.querySelectorAll('dialog[open],#shopify-pc__banner,#shopify-pc__prefs,.drawer--is-open,[data-klaviyo-form]')].filter(visible);
    const editing=/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName||'');
    const chat=chatLayout();
    root.hidden=document.hidden||blockers.length>0||editing||chat.opened;
    if(root.hidden&&(voicePending||!voiceAudio.paused))interruptVoice();
    let bottom=96,buybarHeight=0;
    [...document.querySelectorAll('[data-f-buybar].is-on,[data-nd-buybar].is-visible')].filter(visible).forEach(bar=>{
      buybarHeight=Math.max(buybarHeight,innerHeight-bar.getBoundingClientRect().top);
      bottom=Math.max(bottom,buybarHeight+12);
    });
    const buybarValue=Math.ceil(buybarHeight)+'px';
    if(document.documentElement.style.getPropertyValue('--nk-buybar-height')!==buybarValue)document.documentElement.style.setProperty('--nk-buybar-height',buybarValue);
    const right=innerWidth-(parseFloat(getComputedStyle(root).right)||16),left=right-root.offsetWidth;
    chat.launchers.forEach(control=>{
      const rect=control.getBoundingClientRect();
      if(rect.right>left&&rect.left<right&&rect.top>0&&rect.top<innerHeight)bottom=Math.max(bottom,innerHeight-rect.top+16);
    });
    root.style.setProperty('--nk-obstruction',Math.ceil(bottom)+'px');
    const dockRect=homeDock?.closest('#rooms').getBoundingClientRect();
    const dockInView=!dockRect||(dockRect.top<innerHeight-100&&dockRect.bottom>120);
    if(pending&&!root.hidden&&dockInView){
      const next=pending;pending=null;
      if(next.type==='room')discover(next.room);
      else if(next.type==='resume')resume(false);
      else{transition('PEEKING');launcher.hidden=true;character.hidden=false;later(()=>welcome(),calm()?0:720);}
    }
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(()=>{frame=0;obstruction();});}
  new MutationObserver(records=>{if(records.some(r=>!root.contains(r.target)))schedule();}).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['open','class','hidden','style','aria-expanded']});
  new MutationObserver(()=>{syncMotion();schedule();}).observe(document.documentElement,{attributes:true,attributeFilter:['data-noise','data-motion','style','class']});
  window.addEventListener('resize',schedule);window.addEventListener('scroll',schedule,{passive:true});document.addEventListener('focusin',schedule);document.addEventListener('focusout',schedule);document.addEventListener('visibilitychange',schedule);
  function refreshProgress(){
    const previous=saved.updatedAt;restore();syncMotion();syncLauncher();
    if(saved.updatedAt!==previous&&!gameOpen&&!panel.hidden&&saved.mode==='guided')resume(false);
  }
  window.addEventListener('storage',e=>{if(e.key===key&&preferencesAllowed())refreshProgress();});
  window.addEventListener('focus',refreshProgress);
  window.addEventListener('pageshow',e=>{
    if(!e.persisted)return;
    restore();syncLauncher();
    if(saved.mode==='guided'&&saved.panelOpen){pending={type:'resume'};obstruction();}
    else{pending=null;transition('RESTING');panel.hidden=true;character.hidden=true;launcher.hidden=false;launcher.setAttribute('aria-expanded','false');}
    schedule();
  });
  if(homeDock)new IntersectionObserver(schedule,{threshold:0}).observe(homeDock.closest('#rooms'));
  restore();syncMotion();root.hidden=false;panel.hidden=true;character.hidden=true;launcher.hidden=false;transition('RESTING');root.dataset.progress=String(saved.visited.length);
  if(document.querySelector('[data-play-dialog][open]'))suspendForPlay();
  function start(){
    if(started)return;started=true;restore();obstruction();
    const room=currentRoom();
    if(saved.mode==='guided'&&!saved.completed&&saved.panelOpen&&room&&!saved.visited.includes(room.id)){later(()=>{pending={type:'room',room};obstruction();},700);}
    else if(saved.mode==='guided'&&saved.panelOpen){later(()=>{pending={type:'resume'};obstruction();},700);}
    else if(config.home&&!saved.seen){launcher.hidden=true;later(()=>{pending={type:'welcome'};obstruction();},2600);}
  }
  if(window.Shopify?.loadFeatures&&!window.Shopify.customerPrivacy){window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],start);setTimeout(start,1800);}else start();
})();
